import Vue from 'vue'
import Vuex from 'vuex'
import CredentialsService from "@/services/Credentials.service.js";
import Role from "@/utils/role"
import mutations from './mutations'
import actions from './actions'
import navigation from './navigation'
const credentialService = new CredentialsService()

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: true,
    role: credentialService.getRole(),
    user: credentialService.getCurrentUser(),
    institution: credentialService.getCurrentInstitution(),
    institutions: credentialService.getInstitutions(),
    session: null,
    levels: [],
    events: [],
  },
  getters: {
    isAuthenticated(state) {
      return state.user !== null;
    },
    roles(state) {
      const roles = {
        1: Role.ADMIN,
        2: Role.TEACHER,
        3: Role.STUDENT,
        4: Role.ADMIN_SIS,
      }
      return state.institution && state.institution.roles.map(role => roles[role.type_user_id]);
    }
  },
  mutations,
  actions,
  modules: {
    navigation
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js